export interface CertificationDto {
  hrRef: number;
  code: string;
  description: string;
  skillTester: string;
  certDate: Date | string | null;
  expireDate: Date | string | null;
  score: number | null;
}

export interface SafetyAwarenessDto {
  hrRef: number;
  description: string;
  skillTester: string;
  completeDate: Date | string | null;
  expireDate: Date | string | null;
  score: number | null;
}

export interface TrainingDto {
  hrRef: number;
  description: string;
  skillTester: string;
  completeDate: Date | string | null;
  expireDate: Date | string | null;
  score: number | null;
}

export interface TrainingRecordResponseDto {
  hrRef: number;
  employeeName: string;
  companyNo: number | null;
  last4SSN: string | null;
  profilePhotoFileId: string | null;
  certifications: CertificationDto[];
  safetyAwareness: SafetyAwarenessDto[];
  training: TrainingDto[];
}
